import { SecuredUserManagementClient } from "Core/Api/UserManagement/SecuredUserManagementClient";
import Utility from "Core/Utility";
import { ErrorResultModel } from "Core/Api/UserManagement/Api";


export class LoginForgetPasswordHandler {
    props: any;
    constructor(props) {
        this.props = props;
    }

    SendResetPasswordToken(email: string) {
        let client = new SecuredUserManagementClient();
        return client.authentication_SendResetPasswordToken(email).
            catch(Utility.formatError);
    }
}
